import configHelper from 'helpers/config';
import paginationHelper from 'helpers/pagination';
import reducerHelper from 'helpers/reducers';
import utils from 'helpers/utils';
import {
    BOOKING_STATS_LIST_FILTER_UPDATE,
    BOOKING_STATS_LIST_FILTER_CATEGORY,
    BOOKING_STATS_LIST_PAGE,
    BOOKING_STATS_LIST_SORT,
    FETCH_BOOKING_STATS_FAILURE,
    FETCH_BOOKING_STATS_SUCCESS,
} from 'store/actions/types';

export const ORDER_BY_DAY = 'day';

const initialState = {
    data: {},
    field: 'created_at',
    filter: {},
    filterCategory: reducerHelper.FILTER_BASIC,
    ids: [],
    loading: false,
    offset: 0,
    interval: ORDER_BY_DAY,
    page: 1,
    size: 12,
    total: 0,
};

const convertArrayToBookingStatsObjects = (newData, interval) => {
    const mobianBigBang = configHelper.getMobianBigBang();
    let today = new Date();

    let finalData = {};
    let total = 0;
    let seconds = (today - mobianBigBang) / 1000;

    switch (interval) {
        case 'day':
            total = Math.ceil(seconds / 86400);
            break;
        case 'week':
            total = Math.ceil(seconds / 86400 / 7);
            break;
        case 'month':
            total = ((today.getFullYear() - mobianBigBang.getFullYear()) * 12) + (today.getMonth() - mobianBigBang.getMonth());
            break;
        case 'year':
            total = today.getFullYear() - mobianBigBang.getFullYear();
            break;
        default:
            total = null;
            break;
    }

    utils.each(newData, (obj) => {
        let newValueObject = {};

        newValueObject.id = obj.label;
        newValueObject.label = obj.label;
        newValueObject.interval = interval;

        utils.each(obj.values, (value) => {
            const key = value.currency;

            newValueObject[key] = value;
        });

        finalData[obj.label] = newValueObject;
    });

    return {
        data: finalData,
        total: Math.max(total, length),
    };
};

export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_BOOKING_STATS_FAILURE:
            return Object.assign({}, state, {
                data: {},
                ids: [],
                loading: false,
                offset: 0,
                size: 0,
                total: 0,
            });

        case FETCH_BOOKING_STATS_SUCCESS:
            const newResults = convertArrayToBookingStatsObjects(action.response, action.payload.interval);

            const newIds = action.response.map(function (result) {
                return result.label;
            });

            return Object.assign({}, state, {
                data: Object.assign({}, state.data, newResults.data),
                ids: newIds,
                interval: action.payload.interval,
                loading: false,
                total: newResults.total,
            });

        case BOOKING_STATS_LIST_FILTER_CATEGORY:
            return Object.assign({}, state, {
                filterCategory: action.payload,
            });

        case BOOKING_STATS_LIST_PAGE:
            return Object.assign({}, state, {
                offset: paginationHelper.generateNewOffset(action.payload.page, state.size),
                page: action.payload.page,
            });

        case BOOKING_STATS_LIST_SORT:
            return Object.assign({}, state, {
                field: action.payload.field,
                interval: action.payload.order,
            });

        case BOOKING_STATS_LIST_FILTER_UPDATE:
            const filteredValues = reducerHelper.normaliseState(initialState, action.payload);

            return Object.assign({}, state, filteredValues);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/bookingStatsReducer.js